import React, { forwardRef, PureComponent } from 'react';
import DatePicker from 'react-datepicker';
import { Portal } from 'react-overlays';

const CalendarContainer = ({ children }) => {
    const el = document.getElementById('calendar-portal');
    return (
        <Portal container={el}>
            {children}
        </Portal>
    )
}

class ButtonDatePicker extends PureComponent {

    render() {
        const { value, onChange } = this.props;
        const ref = React.createRef();

        const CustomInput = forwardRef(({ value, onClick }, ref) => (
            <div onClick={onClick} ref={ref} className="btn btn-light" style={{ height: '30px', paddingTop: '3px' }}>
                {value} <span className="badge badge-primary"><i className="fas fa-calendar-plus" ></i></span>
            </div>
        ));

        return (
            <div style={{ border: 'none', position: 'inherit', width: this.props.width }}>
                <DatePicker
                    selected={value}
                    onChange={date => onChange(date, this.props.index)}
                    customInput={<CustomInput />}
                    autoComplete={0} dateFormat='dd-MMM-yyyy'
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="dd-MMM-yyyy" id="inputDate"
                    popperContainer={CalendarContainer}
                />
            </div>
        );
    }
}

export default ButtonDatePicker;